import React, { useState } from "react";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

function AdminAnnisiteDetails({ currentAnnisite, processing, onSave }) {

  const [formData, setFormData]                       = useState(currentAnnisite);
  const [activeTab, setActiveTab]                     = useState("spouses");

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNestedChange = (e, parent, key) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [parent]: {
        ...prev[parent],
        [key]: value,
      },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="container mt-4">
      {/* Bootstrap Nav Tabs */}
      <ul className="nav nav-tabs" id="annisiteTabs" role="tablist">
        <li className="nav-item" role="presentation">
          <button
              className={`nav-link ${activeTab === "spouses" ? "active" : ""}`}
              onClick={() => setActiveTab("spouses")}
            >
            Spouses
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeTab === "contact" ? "active" : ""}`}
            onClick={() => setActiveTab("contact")}
          >
            Contact
          </button>
        </li>
        <li className="nav-item" role="presentation">
           <button
            className={`nav-link ${activeTab === "wedding" ? "active" : ""}`}
            onClick={() => setActiveTab("wedding")}
          >
            Wedding Details
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeTab === "onvite" ? "active" : ""}`}
            onClick={() => setActiveTab("onvite")}
          >
            Onvite Details
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeTab === "onvitemessage" ? "active" : ""}`}
            onClick={() => setActiveTab("onvitemessage")}
            >
              Onvite Message
            </button>
        </li>
        <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === "annivitemessage" ? "active" : ""}`}
              onClick={() => setActiveTab("annivitemessage")}
            >
              Annivite Message
          </button>
        </li>
      </ul>

      {/* Tab Content */}
      <form onSubmit={handleSubmit}>
        <div className="tab-content p-3 border border-top-0" id="annisiteTabsContent">
          {/* SPOUSES */}
          {
              activeTab === "spouses" && (
                <div className="tab-panel-pt fade show">
                    <div className="mb-3">
                      <label>Spouse A</label>
                      <input
                        type="text"
                        className="form-control"
                        name="spouseA"
                        value={formData.spouseA || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label>Wedding Vows A</label>
                      <CKEditor
                          editor={ClassicEditor}
                          data={formData.weddingVowsA || ""}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setFormData(prev => ({ ...prev, weddingVowsA: data }));
                          }}
                        />
                    </div>
                    <div className="mb-3">
                      <label>Spouse B</label>
                      <input
                        type="text"
                        className="form-control"
                        name="spouseB"
                        value={formData.spouseB || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label>Wedding Vows B</label>
                      <CKEditor
                        editor={ClassicEditor}
                        data={formData.weddingVowsB || ""}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setFormData(prev => ({ ...prev, weddingVowsB: data }));
                        }}
                      />
                    </div>
                  </div>
              )
           }
          {/* CONTACT */}
          {
            activeTab === "contact" && (
              <div className="tab-panel-pt">
                  <div className="mb-3">
                    <label>Contact Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="contactName"
                      value={formData.contactName || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label>Contact Email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="contactEmail"
                      value={formData.contactEmail || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label>Contact Phone</label>
                    <input
                      type="text"
                      className="form-control"
                      name="contactPhone"
                      value={formData.contactPhone || ""}
                      onChange={handleChange}
                    />
                  </div>
                </div>
            )
          }          
          {/* WEDDING DETAILS */}
          {
            activeTab === "wedding" && (
              <div className="tab-panel-pt">
                    <div className="mb-3">
                      <label>Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="weddingDate"
                        value={formData.weddingDate || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label>Time</label>
                      <input
                        type="time"
                        className="form-control"
                        name="weddingTime"
                        value={formData.weddingTime || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label>Address</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.weddingAddress?.address || ""}
                        onChange={(e) => handleNestedChange(e, "weddingAddress", "address")}
                      />
                    </div>
                </div>
            )
          }                   

          {/* ONVITE DETAILS */}
          {
            activeTab === "onvite" && (
              <div className="tab-panel-pt" >
                <div className="mb-3">
                  <label>Main Event Title</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.onviteDetails?.mainEventTitle || ""}
                    onChange={(e) => handleNestedChange(e, "onviteDetails", "mainEventTitle")}
                  />
                </div>
                <div className="mb-3">
                  <label>Main Event Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={formData.onviteDetails?.mainEventDate || ""}
                    onChange={(e) => handleNestedChange(e, "onviteDetails", "mainEventDate")}
                  />
                </div>
                <div className="mb-3">
                  <label>Main Address</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.onviteDetails?.mainAddress || ""}
                    onChange={(e) => handleNestedChange(e, "onviteDetails", "mainAddress")}
                  />
                </div>
                <div className="mb-3">
                  <label>Reception Address</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.onviteDetails?.receptionAddress || ""}
                    onChange={(e) => handleNestedChange(e, "onviteDetails", "receptionAddress")}
                  />
                </div>
                <div className="mb-3">
                  <label>Reception Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={formData.onviteDetails?.receptionDate || ""}
                    onChange={(e) => handleNestedChange(e, "onviteDetails", "receptionDate")}
                  />
                </div>
                <div className="mb-3">
                  <label>Reception Start</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.onviteDetails?.receptionStart || ""}
                    onChange={(e) => handleNestedChange(e, "onviteDetails", "receptionStart")}
                  />
                  
                </div>
                <div className="mb-3">
                  <label>Reception End</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.onviteDetails?.receptionEnd || ""}
                    onChange={(e) => handleNestedChange(e, "onviteDetails", "receptionEnd")}
                  />
                </div>
              </div>
            )
          } 
          {/* Onsite Invite Message */}
            {
              activeTab === "onvitemessage" && (
              <div className="tab-panel-pt fade show">
                
                <div className="mb-3">
                  <label>Onsite Message</label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={formData.weddingOnviteMessage || ""}
                    onChange={(event, editor) => {
                    const data = editor.getData();
                    setFormData(prev => ({ ...prev, weddingOnviteMessage: data }));
                    }}
                  />
                </div>
                </div>
              )
            }      
            {/* Annisite Invite Message */}
            {
              activeTab === "annivitemessage" && (
                <div className="tab-panel-pt fade show">
                  
                  <div className="mb-3">
                    <label>Annisite Message</label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.weddingAnniviteMessage || ""}
                      onChange={(event, editor) => {
                      const data = editor.getData();
                      setFormData(prev => ({ ...prev, weddingAnniviteMessage: data }));
                      }}
                    />
                  </div>
                  </div>
                )
              }   
        </div>

        {/* SAVE BUTTON */}
        <div className="mt-3">
          <button type="submit" className="btn btn-primary">
            {processing ? "processing..." : "Save Changes"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AdminAnnisiteDetails;
